import { Snackbar, useMediaQuery } from '@material-ui/core'
import { io } from 'socket.io-client'
import ErrorLine from 'components/ErrorLine'
import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setChatMessages } from 'redux/actions/chatActions'
import parse from 'html-react-parser'
import { getMessage } from 'controllers/SocialServiceController'
import {
  ArrowDropDownCircle,
  DateRangeTwoTone,
  DeleteForeverTwoTone,
  Favorite,
  FavoriteBorderTwoTone,
  FileCopyTwoTone,
  Fullscreen,
  HighlightOffTwoTone,
  Label,
  LabelOff,
  LibraryMusic,
  TimerOffTwoTone,
  VideoLibrary
} from '@material-ui/icons'
import DisplayHarmonizePost from './DisplayHarmonizePost'
import { Alert } from '@mui/material'
import { isVeryNarrow } from 'util/screenUtils'
import { logWithTime } from 'util/screenUtils'
import { displayError } from 'util/screenUtils'
import { getSession } from 'controllers/AIController'
import { setAccessToken } from 'redux/actions/accountActions'
import { setChatSessionId } from 'redux/actions/chatActions'
import { addChatMessage } from 'redux/actions/chatActions'
import DisplaySessions from 'components/vortex/DisplaySessions'
import { getStorageAccount } from 'redux/actions/accountActions'
import { ACCESS_TYPES } from 'components/vortex/CreateVortexRoom'
import { setCurrentCollaborator } from 'redux/actions/chatActions'
import { addSession } from 'controllers/AIController'
import InputAI from 'components/vortex/InputAI'
import { setChatRoomId } from 'redux/actions/chatActions'
import moment from 'moment'
import { AI_TYPE } from 'controllers/AIController'
import { setShowAi } from 'redux/actions/harmonizeActions'
import { deleteSessionThought } from 'controllers/AIController'
import { deleteSession } from 'controllers/AIController'
import { setShowAiWelcome } from 'redux/actions/helpActions'
import BlurDialog from 'components/utility/BlurDialog'
import harmonySmall from '../images/harmony-small.jpg'
import Explain from 'components/Explain'
import TimerProgress from 'components/mint/TimerProgress'
import { replaceNewLine } from 'util/postUtils'
import { getAccountId } from 'redux/actions/accountActions'
import { setPlayListIndex } from 'redux/actions/harmonizeActions'
import { buildNewPlaylistEntries, getVideoSrc } from 'util/playlistUtils'
import { setPlayList } from 'redux/actions/messagesActions'
import { reset } from 'util/playlistUtils'
import DisplayCredits from 'components/transaction/DisplayCredits'
import { setUserStartedPlayback } from 'redux/actions/playerControlActions'
import { setUserPausedMedia } from 'redux/actions/playerControlActions'
import MediaPlayer from 'components/harmonize/MediaPlayer'
import { setMediaSelected } from 'redux/actions/chatActions'
import { canLikePost } from 'util/transactionUtils'
import { isAnonymousAccess } from 'util/transactionUtils'
import { deleteLike } from 'util/socialServiceUtils'
import { addMessageLike } from 'util/messageUtils'
import { isAndroid, isDesktop } from 'react-device-detect'
import { CATEGORY_MODES } from 'redux/reducers/harmonizeReducer'

export const MODALITIES = {
  NONE: 0,
  CHESS: 1,
  MUSIC: 2
}

export const aiChatStyles = {
  label: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontStyle: 'italic',
    fontSize: '0.75em',
  },
  answerLine: {
    borderBottom: '0.5px solid black',
  },
  button: {
    display: 'flex',
    paddingRight: '1em',
    cursor: 'pointer',
    fontSize: '1.5em',
    color: 'red'
  },

  buttonAwesome: {
    display: 'flex',
    paddingRight: '1em',
    cursor: 'pointer',
    fontSize: '1.25em'
  },
  chatDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.25em',
    width: '100%'
  },
  chatContainer: {
    width: '100%'
  },
  chatContainerDesktop: {
    width: '90vw',
    marginLeft: '5vw'
  },
  collaboratorsDiv: {
    flex: '0.4',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: '0.5em',
    height: '70vh',
  },

  mediaIcon: {
    zIndex: 20000,
    fontSize: '2em', color: 'white'
  },
  queryLine: {
    borderBottom: '0.5px dashed gray',
    backgroundColor: 'azure',
  },

  queryInputLine: {
    position: 'fixed',
    bottom: '0',

    backgroundColor: 'white'
  },
  queryInputLineNarrow: {
    position: 'fixed',
    bottom: '0',
    width: '100%',
    backgroundColor: 'white',
    border: '0.5px solid gray',
    display: 'flex',
  },
  sendButton: { width: '90vw' },
  sendButtonNarrow: { width: '80vw' },
  sessionLine: {
    borderBottom: '0.5px dashed gray',
    cursor: 'pointer',
  },
}

let socket
/**
 * The initialQuery is only used for the Session owner. The accessType is used when a Session is created.
 * @param {*} param0 
 * @returns 
 */
export default function AIChat({
  useSessionId,
  messageId,
  ownerOnly,
  roomId,
  roomName,
  //Galaxy Note 8 soft buttons take up part of vh space
  chatHeight = isAndroid ? '85vh' : '90vh',
  accessType = ACCESS_TYPES.PROTECTED,
  initialQuery = ''
}) {
  const veryNarrow = isVeryNarrow(useMediaQuery)

  const account = getStorageAccount()
  const userId = getAccountId()
  const { playList } = useSelector(state => state.messages)
  const { playListIndex } = useSelector(state => state.harmonize)
  const [query, setQuery] = useState(initialQuery)
  const [sentInitialQuery, setSentInitialQuery] = useState(false)
  const [relatedMessages, setRelatedMessages] = useState()
  const [chatCategory, setChatCategory] = useState(CATEGORY_MODES.ALL_MEDIA)
  const { showAiWelcome } = useSelector(state => state.help)
  const { chatMessages, chatSessionId, mediaSelected } = useSelector(
    (state) => state.chat
  )
  const [sessionRoomId, setSessionRoomId] = useState(roomId)
  const [showSessions, setShowSessions] = useState(false)
  const [error, setError] = useState()
  const [answerCopied, setAnswerCopied] = useState(false)
  const [global, setGlobal] = useState(false)
  const [dateSearch, setDateSearch] = useState(false)
  const [speaker, setSpeaker] = useState(null)
  const [connected, setConnected] = useState(false)
  const [explain, setExplain] = useState()
  const [helpTarget, setHelpTarget] = useState()
  const [showRelatedEmbeds, setShowRelatedEmbeds] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const ref = useRef()
  const controlRef = useRef()
  const [thinking, _setThinking] = useState(false)
  const thinkingRef = useRef(thinking)
  const setThinking = (data) => {
    thinkingRef.current = data
    _setThinking(data)
  }

  const [waiting, _setWaiting] = useState(false)
  const waitingRef = useRef(waiting)
  const setWaiting = (data) => {
    waitingRef.current = data
    _setWaiting(data)
  }

  const [currentSession, _setCurrentSession] = useState({
    accessType,
    userId,
  })
  const currentSessionRef = useRef(currentSession)
  const setCurrentSession = (data) => {
    currentSessionRef.current = data
    _setCurrentSession(data)
  }

  const [sessionUsers, _setSessionUsers] = useState([])
  const sessionUsersRef = useRef(sessionUsers)
  const setSessionUsers = (data) => {
    sessionUsersRef.current = data
    _setSessionUsers(data)
  }

  const [readAnswer, _setReadAnswer] = useState(false)
  const readAnswerRef = useRef(readAnswer)
  const setReadAnswer = (data) => {
    readAnswerRef.current = data
    _setReadAnswer(data)
  }

  /**
   * There must be a sessionId before this can be called.
   * 
   * Then, if there is a messageId, connect using that;
   * otherwise if there is a socketRoomId, use that;
   * otherwise there must be a category
   * 
   * @param {*} socketRoomId 
   */
  const configureAndConnectSocket = (socketRoomId, sid = currentSessionRef.current._id) => {
    if (!sid) {
      setError('Unable to connect: there is no Session')
    } else {
      let channelAddress = process.env.REACT_APP_AI_CHAT_SERVICE

      channelAddress += `${sid}/`
      if (messageId) {
        channelAddress += `messageId=${messageId}`
      } else if (socketRoomId) {
        channelAddress += `room=${socketRoomId}`
      } else if (chatCategory) {
        channelAddress += `category=${chatCategory.type}`
      } else {
        throw new Error('Missing category or roomId')
      }

      console.log(`Connect to ${channelAddress}`)
      socket = io(channelAddress)

      /*
       * A join is sent by all users. Only if the username matches this User should a query be
       * sent because it means that User is receiving its own join message.
       */
      socket.on('joinedAiChat', async (joinResponse) => {
        joinedAiChat(joinResponse)
      })

      /* When the Session owner leaves disconnect and that's it */
      socket.on('leftAiChat', async (leftResponse) => {
        logWithTime(`leftAiChat`, leftResponse)
        disconnectChannel()
      })

      /* Only collaborators who did not create the query should see this. */
      socket.on('querySent', async (queryRequest) => {
        logWithTime(`received querySent`, queryRequest)
        setWaiting(true)
        const { query } = queryRequest
        dispatch(addChatMessage({ query }))
      })

      socket.on('answer', async (response) => {
        setThinking(false)
        const {
          answer,
          cost,
          relatedEmbeds,
          relatedMetadata,
          sid,
          thoughtId
        } = response
        logWithTime(`Received answer thoughtId ${thoughtId}`, response)
        const responseMessage = {
          answer,
          cost,
          relatedEmbeds,
          relatedMetadata,
          thoughtId
        }
        if (relatedMetadata) {
          try {
            const relatedMessages = await getRelatedMessages(relatedMetadata)
            if (relatedMessages.length) {
              responseMessage.relatedMessages = relatedMessages
              setRelatedMessages(relatedMessages)
            }
          } catch (error) {
            console.error(`FAILED getting related post, ignored`, error)
          }
        }
        dispatch(addChatMessage(responseMessage))
        if (sid && !chatSessionId) {
          console.log(`Set sessionId to ${sid}`)
          dispatch(setChatSessionId(sid))
          try {
            const session = await getSession(sid)
            setCurrentSession(session)
          } catch (error) {
            displayError(error, setError)
          }
        }
        setWaiting(false)
        //readAnswerText(answer)
      })
      socket.on('reload', (response) => {
        const { sessionId } = response
        populateChatFromSession(sessionId)
      })
      socket.on('error', async (response) => {
        const { message } = response
        console.log(`Received ERROR ${message}`)
        setError(message)
        //await updateAvailableThoughts()
        setWaiting(false)
        //Put back the query that was not executed
        const lastHistory = chatMessages[chatMessages.length - 1]
        if (lastHistory) {
          const { query } = lastHistory
          setQuery(query)
        }
        if (chatMessages.length <= 1) {
          dispatch(setChatMessages([]))
        } else {
          chatMessages.splice(chatMessages.length - 1, 1)
          dispatch(setChatMessages([...chatMessages]))
        }
      })
      socket.on('unauthorized', () => {
        setAccessToken(null)
        history.push(`/SignIn/${roomName}`)
      })

      socket.on('connect', () => {
        logWithTime('socket connected')
        safeEmit('authorize', getAccountId())
      })
      socket.on('connect_error', () => {
        console.error(`Unable to connect to ${channelAddress}`)
        setError(`Unable to connect to Harmonize AI`)
        if (socket) {
          socket.disconnect()
          socket = null
        }
        setConnected(false)
      })

      /*
      socket.on('collaboratorControl', (collaborator) => {
        logWithTime(`collaboratorControl ${collaborator}`)
        dispatch(setCurrentCollaborator(collaborator))
      })
      */
    }
  }

  const channelDisconnected = () => {
    console.log('socket disconnected', socket)
    socket = null
    setConnected(false)
  }

  /**
   * When the AIChat connection to VortexService is authorized, a joinedAIChat event is emitted
   * that contains the connecting User and the current list of user _ids already connected
   * to the AIChat namespace.
   *
   * If the connected user is the owner, then send any initial query. Otherwise, if the list
   * of sessionUsers does not include the owner, we have to wait for that host to join.
   *
   * @param {*} joinResponse
   */
  const joinedAiChat = (joinResponse) => {
    logWithTime(`joinedAiChat`, joinResponse)
    channelConnected()
  }

  const channelConnected = () => {
    console.log('socket connected', socket)
    setConnected(true)

    //When the Social Service is killed with active connections this gets called back with a null socket
    if (socket) {
      sendQuery(true)
      socket.on('unauthorized', () => {
        channelDisconnected()
        setError('You are not signed in')
        history.replace('SignIn')
      })
      socket.on('disconnect', () => {
        channelDisconnected()
      })
    }
  }

  /**
   * This sends a leaveRoom to VortexService AIChat, which in turn disconnects it.
   */
  const disconnectChannel = () => {
    console.log(`AIChat disconnectChannel`)
    safeEmit('leaveRoom')
    setConnected(false)
    setError()
    setSessionUsers([])
    dispatch(setCurrentCollaborator('0'))
  }

  const displayAnswerCopied = () => {
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={answerCopied}
        autoHideDuration={3000}
        onClose={() => setAnswerCopied(false)}
      >
        <Alert onClose={() => setAnswerCopied(false)} severity='success'>
          <span>Answer copied to clipboard</span>
        </Alert>
      </Snackbar>
    )
  }
  const copyLatestAnswer = () => {
    if (chatMessages.length > 1) {
      navigator.clipboard.writeText(
        chatMessages[chatMessages.length - 1].answer
      )
      setAnswerCopied(true)
    }
  }

  const welcomeContent = () => {
    const fontSize = veryNarrow ? '0.9em' : 'inherit'
    return (
      <div style={{ padding: '0.5em' }} onClick={() => dispatch(setShowAiWelcome(false))}>

        <p>Ask questions about all the music and videos in Harmonize.
        </p>
        <p style={{ display: 'flex', alignItems: 'center', fontSize }}>
          A good starting query is 'Tell me about this music'
        </p>

      </div>
    )
  }

  const displayAiWelcome = () => {
    if (showAiWelcome) {
      return (<div onClick={() => dispatch(setShowAiWelcome(false))}>
        <BlurDialog content={welcomeContent}
          image={harmonySmall}
          imageStyle={{ display: 'flex', width: '40vw', marginLeft: 'auto', marginRight: 'auto' }}
          hideHelp
          title='Welcome to Harmonize AI'
          closeIcon close={() => dispatch(setShowAiWelcome(false))}
          top={veryNarrow ? '10vh' : '15vh'} />
      </div>)
    }

  }

  const readAnswerText = (answer) => {
    if (readAnswerRef.current) {
      const u = new SpeechSynthesisUtterance(answer)
      speaker.speak(u)
    }
  }

  const getRelatedMessages = async (relatedMetadata) => {
    const messages = []
    if (relatedMetadata) {
      for (const metadata of relatedMetadata) {
        const { messageId } = metadata
        try {
          const message = await getMessage(messageId)
          messages.push(message)
        } catch (error) {
          console.error(`error retrieving message ${messageId}`, error)
        }
      }
    }
    return messages
  }

  const relatedEmbedsLine = (relatedEmbeds) => {
    if (relatedEmbeds) {
      if (showRelatedEmbeds) {
        let allEmbeds = ''
        for (const emb of relatedEmbeds) {
          allEmbeds += emb.embed + '<br />'
        }
        const jsx = parse(allEmbeds)
        return (
          <div>
            <div style={aiChatStyles.label}>
              Hide embeds&nbsp;
              <LabelOff onClick={() => setShowRelatedEmbeds(false)} />
            </div>
            <div>{jsx}</div>
          </div>
        )
      } else {
        return (
          <div style={aiChatStyles.label}>
            Show embeds&nbsp;
            <Label onClick={() => setShowRelatedEmbeds(true)} />
          </div>
        )
      }
    } else {
      return null
    }
  }

  const playSong = async (msg) => {
    console.log(`AIChat playSong`, playList)
    const { _id } = msg
    const ix = playList.findIndex(pl => pl._id === _id)
    if (ix !== -1) {
      console.log(`AIChat playSong ${ix}`, controlRef.current)
      dispatch(setUserPausedMedia(false))
      dispatch(setUserStartedPlayback(true))
      dispatch(setPlayListIndex(ix))
      controlRef.current.play()
    }
  }

  const relatedMessagesLine = (relatedMessages) => {
    if (relatedMessages) {
      return (
        <div>
          <span style={{ fontWeight: 'bold', justifyContent: 'center', display: 'flex' }}>Related Media</span>
          {relatedMessages.map((msg, ix) => (
            <div key={ix} style={{ cursor: 'pointer' }} >
              <DisplayHarmonizePost content={msg} fromAi={true} selected={() => {
                playSong(msg)
              }} />
            </div>
          ))}
        </div>
      )
    } else {
      return null
    }
  }

  /**
 * If the Thought was retrieved from the Core Service, then we have a thoughtId with the query.
 * Otherwise, the Thought was just created by the AI query and the id of the THought created for
 * that is returned with the answer and stored into the chatMessage answer.
 * @param {*} thoughtId 
 * @param {*} ix 
 * @returns 
 */
  const deleteChatLine = async (thoughtId, ix) => {
    let actualThoughtId = thoughtId
    if (!thoughtId && ix + 1 < chatMessages.length) {
      const answer = chatMessages[ix + 1]
      actualThoughtId = answer.thoughtId
    }
    if (actualThoughtId) {
      try {
        await deleteSessionThought(actualThoughtId)
        populateChatFromSession(chatSessionId)
        safeEmit('reload', chatSessionId)
      } catch (error) {
        displayError(error, setError)
      }
    }
  }


  const displayDeleteChatLine = (thoughtId, ix) => {
    const { userId: sessionUserId } = currentSessionRef.current
    if (sessionUserId === userId) {

      return (
        <div title='Click to delete this Query and Answer' style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          <DeleteForeverTwoTone
            color='error'
            fontSize='small'
            onClick={(evt) => {
              evt.stopPropagation()
              deleteChatLine(thoughtId, ix)
            }}
          />
        </div>
      )
    }
  }

  const displayText = (chatEntry, ix) => {
    const { answer, relatedEmbeds, relatedMessages } =
      chatEntry
    const formattedAnswer = parse(replaceNewLine(answer))
    return (
      <div key={ix}>
        <p>A: {formattedAnswer}</p>
        {relatedEmbedsLine(relatedEmbeds)}
        {relatedMessagesLine(relatedMessages)}
      </div>)
  }

  const formatChatLine = (chatEntry, ix) => {
    const { thoughtId, query, answer } =
      chatEntry
    if (query) {
      return <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }} key={ix}>
        Q: {query}{displayDeleteChatLine(thoughtId, ix)}
      </div>
    } else {
      try {
        const parsedAnswer = JSON.parse(answer)
        if (Array.isArray(parsedAnswer)) {
          const img = parsedAnswer[0]
          return (
            <div key={ix} style={{ display: 'flex', justifyContent: 'center' }}>
              <img
                src={img.url}
                style={{ width: '50%' }}
              />
            </div>
          )
        }
      } catch {

      }
      return displayText(chatEntry, ix)
    }

  }

  const displayChatLine = (chatEntry, ix) => {
    const { query } = chatEntry
    return (
      <div
        key={ix}
        style={query ? aiChatStyles.queryLine : aiChatStyles.answerLine}
      >
        {formatChatLine(chatEntry, ix)}
      </div>
    )
  }

  const displayChat = () => {
    if (account) {
      return (
        <div style={{
          backgroundColor: 'white', width: '100%', display: 'flex',
          flexDirection: 'column', height: mediaSelected ? '20vh' : chatHeight
        }}>
          <div
            ref={ref}
            style={{
              border: '1px solid black',
              height: '100%',
              overflowY: 'scroll',
              paddingLeft: veryNarrow ? '0.25em' : '1em',
              width: '100%',
              paddingRight: veryNarrow ? '0.25em' : '1em',
            }}
          >
            {chatMessages.map((chat, ix) => displayChatLine(chat, ix))}
          </div>

          <InputAI
            roomName={roomName}
            getQuery={() => { return query }}
            updateQuery={(query) => setQuery(query)}
            send={() => {
              sendQuery(connected)
            }}

          />
        </div>
      )
    }
  }

  const displaySessions = () => {
    return (
      <div style={{ width: '100%' }}>
        <DisplaySessions
          sessionsHeight={veryNarrow ? '56vh' : '70vh'}
          handleSession={async (sessionId) => {
            console.log(`handleSession ${sessionId}`)
            setShowSessions(false)
            await populateChatFromSession(sessionId)
          }}
          sessionDeleted={async (sess) => {
            try {
              if (sess && sess.length) {
                setShowSessions(false)
                const { _id } = sess[0]
                const session = await getSession(_id)
                dispatch(setChatSessionId(_id))
                setCurrentSession(session)
                await buildChatMessages(session.thoughts)
              } else {
                await createSession()
              }
            } catch (error) {
              displayError(error, setError)
            }
          }}
        />
      </div>
    )
  }

  const scrollToBottom = (targetRef) => {
    if (targetRef.current) {
      const scroll =
        targetRef.current.scrollHeight - targetRef.current.clientHeight
      targetRef.current.scrollTo(0, scroll)
    }
  }

  const onSpeechCommand = (turnOn) => {
    setReadAnswer(turnOn)
    setQuery('')
    speaker.speak(new SpeechSynthesisUtterance(turnOn ? 'Started' : 'Stopped'))
  }
  const checkSpeechCommand = (queryToSend) => {
    const command = queryToSend.trim().toLowerCase()
    switch (command) {
      default:
        return false
      case 'start reading':
        onSpeechCommand(true)
        return true
      case 'stop reading':
        onSpeechCommand(false)
        return true
    }
  }

  const displayThinking = () => {
    if (thinkingRef.current) {
      return (

        <div
          style={{
            backgroundColor: 'rgba(127,127,127,0.6)',
            width: '100%',
            height: '100%',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 150,
            backdropFilter: 'blur(5px)',
          }}
          onClick={() => setThinking(false)}
        >
          <div style={{ color: 'white', marginTop: '40vh' }}>

            <TimerProgress label='Thinking...' />
          </div>
        </div>
      )
    }
  }

  /**
   * 
   * @param {*} socketIsConnected
   */
  const sendQuery = (socketIsConnected) => {
    const queryLength = query.trim().length
    if (queryLength) {
      if (!checkSpeechCommand(query)) {
        try {
          if (!socketIsConnected) {
            configureAndConnectSocket(sessionRoomId)
          } else {
            //let updatedHistory = chatMessages
            //updatedHistory.push({ query })
            dispatch(addChatMessage({ query }))
            setQuery('')
            setError('')
            setWaiting(true)
            if (speaker && readAnswerRef.current) {
              speaker.speak(new SpeechSynthesisUtterance('Thinking'))
            }
            //dispatch(setChatMessages(updatedHistory))
            let queryParams = { query, global }
            if (dateSearch) {
              const createdAt = moment().subtract(60, 'days').unix()
              console.log(`dateSearch from ${createdAt}`)
              queryParams.createdAt = createdAt
            }
            console.log('sendQuery', queryParams)
            setThinking(true)
            safeEmit('query', queryParams)
          }
        } catch (error) {
          console.error(error)
          displayError(error, setError)
        }
      }
    }
  }

  /**
   * If initialQuery is specified then it has been set into query when the instance is created.
   * Once we have a Session we must send the query because this is when
   * configureAndConnectSocket is called.
  */
  const sendInitialQuery = () => {
    if (initialQuery && initialQuery.length && !sentInitialQuery) {
      console.log(`send initial query ${initialQuery}`)
      setSentInitialQuery(true)
      sendQuery(false)
    }
  }

  /**
   * If we have not started from an existing Session (useSessionId specified in AIChat call)
   * then we have to create a new one on the Core Service and use it to connect to the Social 
   * Service. Once we have it we can send a query.
   */
  const createSession = async () => {
    logWithTime(`createSession accessType ${accessType}`)
    try {
      resetCurrentSession(false)
      const aiIdentifier = roomId ? roomId : chatCategory.type
      const aiType = roomId ? AI_TYPE.STUDIO : AI_TYPE.CATEGORY
      const sess = await addSession(aiIdentifier, aiType, accessType)
      if (sess) {
        const { _id, userId } = sess
        dispatch(setChatRoomId(roomId))
        dispatch(setChatSessionId(_id))
        dispatch(setPlayListIndex(0))
        dispatch(setPlayList([]))
        logWithTime(`...new Session ${_id}`)
        setCurrentSession({ ...sess, userId })
        logWithTime('got new session', sess)
        setShowSessions(false)
        sendInitialQuery()
      } else {
        setError('Unable to create a Harmonize AI Session')
      }
    } catch (error) {
      displayError(error, setError)
    }
  }

  /**
   * 
   * @param {*} thought 
   * @param {*} msgOut 
   */
  const buildChatMessage = async (thought, msgOut) => {
    const { _id, query, answer, relatedMetadata } = thought
    const relatedMessages = await getRelatedMessages(relatedMetadata)
    const newPlaylist = await buildNewPlaylistEntries(relatedMessages)
    //dispatch(setPlayListIndex(0))
    dispatch(setPlayList(newPlaylist))
    msgOut.push({ query, thoughtId: _id })
    msgOut.push({ answer, relatedMessages })
  }

  /**
   * 
   * @param {*} thoughts 
   */
  const buildChatMessages = async (thoughts) => {
    let messages = []
    for await (const thought of thoughts) {
      await buildChatMessage(thought, messages)
    }
    dispatch(setChatMessages(messages))
  }

  /**
   * Retrieve the selected Session and its Thoughts, then populate chatMessages
   * with the Thoughts and if the sessionId has changed send the selected Session _id to the server.
   * 
   * Ensure the Session belongs to this Room.
   * 
   * @param {*} sid Id of Session to get
   */
  const populateChatFromSession = async (sid, loadSessions) => {
    logWithTime(`populateChatFromSession ${sid} loadSessions ${loadSessions} ownerOnly ${ownerOnly} connected ${connected}`)
    try {
      setWaiting(true)
      const session = await getSession(sid)
      await buildChatMessages(session.thoughts)
      logWithTime(`populateChatFromSession got session`, session)
      if (!session) {
        await createSession()
      } else {
        const { thoughts, room, userId: sessionUserId } = session
        if (ownerOnly && sessionUserId !== userId) {
          logWithTime(`...populateChatFromSession: current user not Session owner`)
          await createSession()
        } else {
          setCurrentSession(session)
          dispatch(setChatRoomId(roomId))
          dispatch(setChatSessionId(sid))
          if (loadSessions) {
            setSessionRoomId(room)
          }
          //readyForCollaborators(session)
          if (isAccessAllowed(session)) {
            await buildChatMessages(thoughts)
            setShowSessions(false)
            if (!connected) {
              configureAndConnectSocket(room, sid)
            } else {
              if (sid !== chatSessionId) {
                dispatch(setChatSessionId(sid))
                if (connected) {
                  safeEmit('sessionId', { sessionId: sid })
                }
              }
            }

          }
        }
      }
    } catch (error) {
      console.error('...error', error)
      if (error.statusCode === 404) {
        await createSession()
      } else {
        resetCurrentSession(false)
        displayError(error, setError)
      }
    }
    setWaiting(false)
  }

  /**
   * Call this if the current session is deleted or refreshed.
   * @param {*} sendSessionId If true the sessionId is sent to the Social Service
   */
  const resetCurrentSession = (sendSessionId = true) => {
    dispatch(setChatRoomId(null))
    dispatch(setChatSessionId(null))
    dispatch(setChatMessages([]))
    setSessionUsers([])
    if (sendSessionId) {
      safeEmit('sessionId', { sessionId: null })
    }
  }

  const safeEmit = (msg, data) => {
    if (socket) {
      socket.emit(msg, data)
    }
  }

  const isAccessAllowed = (sess) => {
    const { accessType, userId: sessionUserId } = sess
    return accessType !== ACCESS_TYPES.PRIVATE || sessionUserId === userId
  }

  const displayChatOrSessions = () => {

    return (
      <div style={{ display: 'flex', width: '100vw' }}>

        {showSessions ? displaySessions() : displayChat()}

      </div>
    )
  }

  const displaySimple = () => {
    return (
      <>
        <ErrorLine error={error} />
        {displayAnswerCopied()}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div
            title='Click to copy the latest answer'
            style={aiChatStyles.button}
          >
            <FileCopyTwoTone color='primary' onClick={() => copyLatestAnswer()} />
          </div>
        </div>
        <div style={{ display: 'flex', width: '100%' }}>
          {displayChatOrSessions()}
        </div>
      </>
    )
  }
  const getSong = () => {
    if (playList.length && playListIndex < playList.length) {
      return playList[playListIndex]
    } else {
      return { accessType: ACCESS_TYPES.PROTECTED, name: '', numLikes: 0, liked: false }
    }
  }
  const deleteLikeFromMessage = () => {
    const { _id: messageId, accessType, userId: songUserId } = getSong()
    if (canLikePost(userId, songUserId, isAnonymousAccess(accessType))) {
      try {
        deleteLike(messageId, userId, socket)
      } catch (error) {
        console.error('error deleting like', error)
        displayError(error, setError, 3)
      }
    }
  }
  const addLikeToMessage = async () => {
    try {
      await addMessageLike(userId, getSong(), playList, dispatch)
    } catch (error) {
      displayError(error, setError)
    }
  }
  const displayFullscreen = () => {
    if (getVideoSrc(getSong())) {
      return (
        <Fullscreen
          style={aiChatStyles.mediaIcon}
          onClick={controlRef ? () => controlRef.current.fullscreen() : null} />)
    }
  }
  const displayLiked = () => {
    const { liked } = getSong()
    if (liked) {
      return <Favorite style={aiChatStyles.mediaIcon}
        onClick={(evt) => {
          evt.stopPropagation()
          deleteLikeFromMessage()
        }} />
    } else {
      return <FavoriteBorderTwoTone style={aiChatStyles.mediaIcon}
        onClick={(evt) => {
          evt.stopPropagation()
          addLikeToMessage()
        }} />
    }
  }

  const displayMain = () => {
    const { _id } = currentSession
    if (!isAccessAllowed(currentSession)) {
      return <div>This Session is private</div>
    } else {
      const musicSelected = chatCategory.type === (CATEGORY_MODES.ALL_MEDIA.type)
        || chatCategory.type === (CATEGORY_MODES.MUSIC.type)
      const videoSelected = chatCategory.type === (CATEGORY_MODES.ALL_MEDIA.type)
        || chatCategory.type === (CATEGORY_MODES.VIDEO.type)
      return (
        <div>
          {!messageId ?
            (<div>

              <ErrorLine error={error} />
              {displayAnswerCopied()}
              <div style={isDesktop ? aiChatStyles.chatContainerDesktop : aiChatStyles.chatContainer}>
                {!showSessions ?
                  <div style={aiChatStyles.chatDiv}>

                    <DisplayCredits song={getSong()} displayStyle={{ marginTop: 0 }}
                      textStyle={{ color: 'black' }}
                    />
                    <div
                      title='Click to copy the latest answer'
                      style={aiChatStyles.button}
                    >
                      <FileCopyTwoTone color='primary' onClick={() => copyLatestAnswer()} />
                    </div>
                    <div
                      style={aiChatStyles.button}
                    >
                      <LibraryMusic color={musicSelected ? 'primary' : 'disabled'}
                        onClick={async (evt) => {
                          evt.stopPropagation()
                          if (videoSelected) {
                            const newCategoryMode = musicSelected ? CATEGORY_MODES.VIDEO : CATEGORY_MODES.ALL_MEDIA
                            setChatCategory(newCategoryMode)
                            safeEmit('category', newCategoryMode.type)
                          }
                        }} />
                    </div>
                    <div
                      style={aiChatStyles.button}
                    >
                      <VideoLibrary color={videoSelected ? 'primary' : 'disabled'}
                        onClick={async (evt) => {
                          evt.stopPropagation()
                          if (musicSelected) {
                            const newCategoryMode = videoSelected ? CATEGORY_MODES.MUSIC : CATEGORY_MODES.ALL_MEDIA
                            setChatCategory(newCategoryMode)
                            safeEmit('category', newCategoryMode.type)
                          }
                        }} />
                    </div>
                    <HighlightOffTwoTone style={{ fontSize: '2em' }}
                      onClick={async () => {
                        console.log('delete currentSession', currentSession)
                        disconnectChannel()
                        reset(dispatch)
                        dispatch(setShowAi(false))
                        dispatch(setMediaSelected(false))
                        if (!chatMessages.length) {
                          await deleteSession(_id)
                          dispatch(setChatSessionId(null))
                        }
                      }} />

                  </div> : null}
                <div style={{ display: 'flex', width: '100%' }}>
                  {displayChatOrSessions()}
                </div>
                <div style={{ position: 'relative', visibility: mediaSelected ? 'visible' : 'hidden' }}>
                  <div style={{ position: 'absolute', top: 0, display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                    {displayLiked()}
                    {displayFullscreen()}
                    <ArrowDropDownCircle
                      onClick={(evt) => {
                        evt.stopPropagation()
                        dispatch(setMediaSelected(false))
                        if (controlRef.current) {
                          controlRef.current.pause()
                        }
                      }}
                      style={aiChatStyles.mediaIcon} />
                  </div>
                  <MediaPlayer
                    ref={controlRef}
                    dispatch={dispatch}
                    autoplay={false}
                    videoStyle={{
                      height: '60vh', width: '100vw', objectFit: 'contain'
                    }} />
                </div>

              </div>
            </div >) : displaySimple()
          }

          <div>

          </div>
          {displayAiWelcome()}
          {displayThinking()}
          {
            explain && (
              <Explain
                source={explain}
                target={helpTarget}
                close={() => setExplain(null)}
              />
            )
          }
        </div >
      )
    }
  }

  const displaySummarizeDate = () => {
    if (process.env.REACT_APP_MODE === 'development') {
      if (dateSearch) {
        return (
          <div
            title='Click to disable summary'
            style={aiChatStyles.button}
            onClick={() => setDateSearch(false)
            }
          >
            <TimerOffTwoTone />
          </div >
        )
      } else {
        return (
          <div
            title='Click to summarize'
            style={aiChatStyles.button}
            onClick={async () => {
              await createSession()
              setDateSearch(true)
            }}
          >
            <DateRangeTwoTone />
          </div>
        )
      }
    }
  }

  /**
   * Effin a. OK the way these work is that each useEffect with its dependency is equivalent to the
   * old setState(),()=>func(). So by not having the waiting dependency on the second useEffect,
   * we ensure that the disconnect is only called when chatCategory changes or the page is exited.
   */
  useEffect(() => {
    //console.log(`AIChat useEffect waitingRef.current ${waitingRef.current} connected ${connected}`)
    scrollToBottom(ref)
  }, [waitingRef.current])

  /**
   * When we get new Messages from the related metadata included with an AI answer,
   * update the playlist so that references from previous answers in this session
   * are still valid.
   */
  useEffect(() => {
    const handleRelatedMessages = async () => {
      if (relatedMessages.length) {
        console.log('playList', playList)
        const newPlaylist = await buildNewPlaylistEntries(relatedMessages)
        console.log('newPlaylist', newPlaylist)
        const filteredPlaylist = newPlaylist.filter(pl => playList.findIndex(px => px._id === pl._id) === -1)
        console.log('filteredPlaylist', filteredPlaylist)
        const updatedPlayList = [...playList, ...filteredPlaylist]
        console.log('updatedPlaylist', updatedPlayList)
        dispatch(setPlayList(updatedPlayList))
        setRelatedMessages()
      }
    }
    if (relatedMessages) {
      handleRelatedMessages()
    }
  }, [relatedMessages])
  /*
  useEffect(() => {
  
    return () => {
      console.log(`useEffect 2 return ${chatCategory} waiting ${waiting}`)
      disconnectChannel()
    }
            // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatCategory])
  */

  useEffect(() => {
    console.log(`AIChat useEffect useSessionId ${useSessionId}`)
    createSession()
    /*
    if (useSessionId) {
      populateChatFromSession(useSessionId, true)
    } else {
      createSession()
    }
    */
    /*
    const synth = window.speechSynthesis
    setSpeaker(synth)
  
    return () => {
      synth.cancel()
      setSpeaker(null)
    }
    */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  return displayMain()
}
